export const HookIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <mask
      id="mask0_9038_2793"
      width="24"
      height="24"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z"></path>
    </mask>
    <g mask="url(#mask0_9038_2793)">
      <path
        fill="#D84334"
        d="M11 21q-2.5 0-4.25-1.75T5 15V9l5 5-1.4 1.425-1.6-1.6V15q0 1.65 1.175 2.825T11 19t2.825-1.175T15 15v-3.175a3.16 3.16 0 0 1-1.45-1.112A2.86 2.86 0 0 1 13 9q0-.95.55-1.713.55-.762 1.45-1.112V2h2v4.175q.9.35 1.45 1.112T19 9t-.55 1.725-1.45 1.1V15q0 2.5-1.75 4.25T11 21m5-11q.424 0 .712-.287A.97.97 0 0 0 17 9a.97.97 0 0 0-.288-.713A.97.97 0 0 0 16 8a.97.97 0 0 0-.713.287A.97.97 0 0 0 15 9q0 .424.287.713.288.287.713.287"
      ></path>
    </g>
  </svg>
);
